import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";

import RowShell from "./RowShell";

function SportsList({ items, loading }) {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={3}>
        <CircularProgress size={28} />
      </Box>
    );
  }
  if (!items.length) {
    return (
      <Typography variant="body2" color="textSecondary">
        No sport levels assessed yet
      </Typography>
    );
  }
  // A client can hold two levels in the same sport, so each row gets its own
  // chip — the sport alone is not a unique key.
  return items.map((s) => (
    <RowShell key={`${s.sportId}:${s.levelValue}`}>
      <Box flex={1} minWidth={0}>
        <Typography variant="subtitle2">{s.sportName}</Typography>
      </Box>
      <Chip
        size="small"
        color="primary"
        variant="outlined"
        label={s.levelName ? `Level ${s.levelValue} · ${s.levelName}` : `Level ${s.levelValue}`}
        sx={{ fontWeight: 600, textTransform: "capitalize" }}
      />
    </RowShell>
  ));
}

export default SportsList;
